import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=5c429945&"
import script from "./Notifications.js?vue&type=script&lang=js&"
export * from "./Notifications.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c429945')) {
      api.createRecord('5c429945', component.options)
    } else {
      api.reload('5c429945', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=5c429945&", function () {
      api.rerender('5c429945', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Notifications/Notifications.vue"
export default component.exports